import { Typography } from "@fullscript/aviary-web";

import * as styles from "./CustomDisclaimer.styles";

interface Props {
  disclaimer: string;
}

export const CustomDisclaimer = ({ disclaimer }: Props) => {
  return (
    <div css={styles.container}>
      <div css={styles.content}>
        <Typography variant="footnote" intention="neutral" colorIntensity="subtle">
          {disclaimer}
        </Typography>
      </div>
    </div>
  );
};
